import axios from "axios"
import { APIURL } from "../Constantes"
import { getCabecera } from "../utils/getCabecera"
import { getError } from "../utils/errors"

const urlBinnacle = "Binnacle"

/**
 * *Metodos para los reportes de comaprtir en redes sociales
 */


//* Consulta reportes imagenes
//* GET api/Binnacle/Image
export const getReporteImagenShareAll = async () => {
    return axios.get(`${APIURL}/${urlBinnacle}/Image`,
        {
            headers: getCabecera()
        }).then((Response) => {
            return Response.data;
        }).catch((Error) => {
            return [];
        })
}
//* Consulta reportes imagenes
//* GET api/Binnacle/Image/Count
export const getReporteImagenShareAllCount = async () => {
    return axios.get(`${APIURL}/${urlBinnacle}/Image/Count`,
        {
            headers: getCabecera()
        }).then((Response) => {
            return Response.data;
        }).catch((Error) => {
            return {};
        })
}
//* Consulta reportes de clientes que intentaron registrar los agentes
//* GET /api/Binnacle/Register/Client/Binnacle/{Pagina}/{Registros}
export const getReporteClientesIntentoRegistro = ({pagina, registros}) => {
    return axios.get(`${APIURL}/${urlBinnacle}/Register/Client/Binnacle/${pagina}/${registros}`,
        {
            headers: getCabecera()
        }).then((Response) => {
            return Response.data;
        }).catch((Error) => {
            return [];
        })
}